<script lang="ts" setup>
const options = useOptions()
const stepsStore = useStepsStore()
const isFirstStep = computed(() => stepsStore.currentStepIndex === 0)

const show = ref(false)

const screen = useScreen()
watch(
  screen.md,
  matches => {
    show.value = matches
  },
  { immediate: true },
)

const showFaq = ref(false)
</script>

<template>
  <div class="flex-shrink-0 sm:mb-12 md:mb-[3.75rem] md:w-[480px] lg:w-[640px]">
    <Dialog
      v-if="options.faqQuestions.length > 0"
      :open="showFaq"
      @close="showFaq = false"
      size="small"
    >
      <div class="px-6 pb-8 pt-16 s:pt-8 sm:px-8 sm:py-10 md:px-12 md:py-16 lg:px-16 lg:py-16">
        <H level="2" class="mb-0 mt-0">Häufig gestellte Fragen</H>

        <template v-for="item in options.faqQuestions">
          <h4>{{ item.question }}</h4>
          <div v-html="item.answer" />
        </template>
      </div>
    </Dialog>

    <RekaCollapsibleRoot v-model:open="show" class="md:contents" :unmount-on-hide="false">
      <RekaCollapsibleTrigger as-child>
        <Button class="fixed bottom-2 right-2 z-40 shadow-lg md:hidden" theme="default-dense">
          <template #icon-before>
            <IconPreview />
          </template>
          Vorschau
        </Button>
      </RekaCollapsibleTrigger>
      <RekaCollapsibleContent as-child>
        <div
          class="bottom-[var(--bottom-offset)] top-[var(--top-offset)] contents [--bottom-offset:0px] [--mobile-header-offset:var(--header-height)] [--top-offset:0px] md:sticky md:left-auto md:right-auto md:block md:max-h-[calc(100vh-var(--top-offset)-var(--bottom-offset))] md:overflow-auto md:[--bottom-offset:6rem] md:[--top-offset:calc(0.5rem+var(--admin-bar-height,0px)+var(--mobile-header-offset))] lg:[--mobile-header-offset:0px]"
        >
          <div
            class="fixed bottom-14 left-0 right-0 top-[var(--admin-bar-height,0px)] z-40 flex items-center justify-center overflow-auto bg-black p-2 transition-transform duration-700 md:static md:block md:overflow-visible md:bg-transparent md:p-0"
            :class="{
              'translate-x-full': !show,
              'translate-none': show,
            }"
            :inert="!show"
          >
            <div class="w-full max-w-[640px] md:border md:border-black">
              <Announcement :show-fallbacks="stepsStore.currentStepIndex === 0" show-watermark />
            </div>
          </div>
          <div class="flex items-baseline justify-between gap-4">
            <div
              v-if="isFirstStep"
              class="fixed bottom-0 left-0 flex h-14 w-full items-center text-balance bg-black pl-2 pr-36 text-s leading-none text-white transition-transform duration-700 sm:pl-36 md:static md:h-auto md:bg-transparent md:px-0 md:text-inherit"
              :class="{
                'translate-x-full': !show,
                'translate-none': show,
              }"
              :inert="!show"
            >
              <p class="m-0 py-1">
                Nicht verwendete Bausteine werden im nächsten Schritt ausgeblendet.
              </p>
            </div>
            <div
              v-if="options.faqQuestions.length > 0"
              :class="{
                'ml-auto': !isFirstStep,
              }"
            >
              <Button
                theme="text-accent-standalone"
                class="whitespace-nowrap"
                @click="showFaq = true"
              >
                Häufig gestellte Fragen
              </Button>
            </div>
          </div>
        </div>
      </RekaCollapsibleContent>
    </RekaCollapsibleRoot>
  </div>
</template>
